const GRID_COLUMN_MODES = ['xlarge', 'large', 'regular']

class GridSwitcher extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)
    this.onExternalChange = this.onExternalChange.bind(this)

    this.els?.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.onTriggerClick)
    })

    window.addEventListener('grid-switcher:change', this.onExternalChange)

    const gridTarget =
      this.closest('[data-grid-switcher-external-el="grid"]') ??
      document.querySelector('[data-grid-switcher-external-el="grid"]')
    const columns = gridTarget?.getAttribute('data-columns') || 'regular'

    this.updateTriggerState(columns)
  }

  onTriggerClick (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)
    const columns = triggerEl?.dataset.columns

    if (!columns) return

    // Update this instance
    this.updateTriggerState(columns)

    // Update other instances
    window.dispatchEvent(
      new CustomEvent('grid-switcher:change', {
        detail: {
          columns,
          source: this,
        },
      }),
    )

    this.setCartAttribute('collection_grid_columns', columns)

    const gridTarget =
      this.closest('[data-grid-switcher-external-el="grid"]') ??
      document.querySelector('[data-grid-switcher-external-el="grid"]')

    gridTarget?.setAttribute('data-columns', columns)
  }

  onExternalChange (event) {
    const { columns, source } = event.detail

    // Avoid updating self if already triggered
    if (source === this) return

    this.updateTriggerState(columns)
  }

  updateTriggerState (columns) {
    const normalised = GRID_COLUMN_MODES.includes(columns)
      ? columns
      : 'regular'

    this.els?.trigger?.elements.forEach((triggerEl) => {
      const isActive = triggerEl.dataset.columns === normalised

      triggerEl.setAttribute('aria-pressed', isActive)
    })
  }

  setCartAttribute (attributeKey, attributeValue) {
    // eslint-disable-next-line compat/compat
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [attributeKey]: attributeValue,
        },
      }),
    })
  }
}

if (!customElements.get('grid-switcher')) {
  customElements.define('grid-switcher', GridSwitcher)
}
